import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingService } from './setting.service';
import { Observable } from 'rxjs';

@Injectable()
export class RegistrationService {

  constructor(
    private settings: SettingService,
    private http: HttpClient
  ) {}

  api = 'school-program-http/api/v1';

  getChildren(): Observable<any> {
    const requestUrl = this.settings.getConfig('client.url') + `/customer/dashboard/parent/children`;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithToken());
  }

  getDetailStudentWithClass(id: number): Observable<any> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/students/get-detail-student-with-class/' + id;
    return this.http.get<any>(requestUrl, this.settings.httpOptionWithToken());
  }

  getPeriod(id: number): Observable<any> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer' + '/extracurricular/registration/period/' + id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithToken()); 
  }

  getPeriodV2(id: number): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/registration/student-data/' + id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/registration/student-data/' + id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  getExcul(id: number): Observable<any> {
    const requestUrl = this.settings.getConfig('client.url') + '/customer' + '/extracurricular/registration/excul/' + id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithToken());
  }
  
  getExculV2(studentId: number): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/registration/' + studentId;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/registration/' + studentId;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  addParticipant(id: number, data: any) {
    const requestUrl = this.settings.getConfig('client.url') + '/customer/extracurricular/excul/' + id + '/participant';

    return this.http.put<any>(requestUrl,
      JSON.parse(JSON.stringify(data)),
      this.settings.httpOptionWithToken());
  }

  registActivity(data: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/registration';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/registration';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(data)), this.settings.httpOptionWithSession());
  }

  studentAcademicData(id: number) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/registration/student-detail/' + id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/registration/student-detail/' + id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  getPeriodList() {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/registration/period';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/registration/period';

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  confirmManualPayment(id: number, data: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/registration/payment/' + id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/registration/payment/' + id;

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(data)), this.settings.httpOptionWithSession());
  }

  getStudentRegistration(params: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/registration/list';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/registration/list';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(params)), this.settings.httpOptionWithSession());
  }

  onApproveRegistration(id: number, data: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/registration/approve/' + id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/registration/approve/' + id;

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(data)), this.settings.httpOptionWithSession());
  }

  onApprovePaymentBulk(data: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/registration/payment/bulk-approve';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/registration/payment/bulk-approve';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(data)), this.settings.httpOptionWithSession());
  }

  getStudentRegistrationPayment(params: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/registration/payment/list';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/registration/payment/list';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(params)), this.settings.httpOptionWithSession());
  }

  getStudentRegistrationPaymentDetailByActivity(id: number): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/payment/' + id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/payment/' + id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  getStudentActivityPayment(params: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/student-activity-payment';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/student-activity-payment';

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

  getRegistrationPaymentManualLogs(registrationPaymentId: number): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/payment-manual-log/' + registrationPaymentId;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/payment-manual-log/' + registrationPaymentId;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

}
